// SPDX-License-Identifier: Elastic-2.0
/**
 * TopBar — generic 3-column header.
 *
 * 64px tall, sticky, token-styled. Each slot (left / center / right) is
 * independently optional — the slot renders only if a node is passed.
 *
 * Content is the caller's job: T-020 fills with wordmark + theme pill in
 * `left`, command-K search in `center`, and bell + avatar in `right`.
 */
import type { HTMLAttributes, ReactNode } from "react";

import styles from "./TopBar.module.css";

export interface TopBarProps extends HTMLAttributes<HTMLElement> {
  left?: ReactNode;
  center?: ReactNode;
  right?: ReactNode;
}

export function TopBar({
  left,
  center,
  right,
  className,
  ...rest
}: TopBarProps): JSX.Element {
  const composed = [styles.topbar, className].filter(Boolean).join(" ");
  return (
    <header className={composed} role="banner" {...rest}>
      {left !== undefined && <div className={styles.left}>{left}</div>}
      <div className={styles.center}>{center}</div>
      {right !== undefined && <div className={styles.right}>{right}</div>}
    </header>
  );
}
